import { type ReactNode } from 'react'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { TeamListHeader } from '@/features/iam/teams/components/TeamListHeader'
import { TeamListFooter } from '@/features/iam/teams/components/TeamListFooter'
import { ScrollView } from '@/components/ScrollView'

export interface TeamListProps {
  searchText: string
  onSearchTextChange: (value: string) => void
  onCreateTeamRequest: () => void
  showCreateAction: boolean
  children?: ReactNode
}

export function TeamList({
  searchText,
  onSearchTextChange,
  onCreateTeamRequest,
  showCreateAction,
  children,
}: TeamListProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  return (
    <Sandwich stretch>
      <SandwichBun>
        <TeamListHeader
          searchText={searchText}
          onSearchTextChange={onSearchTextChange}
          scrollOffset={scrollOffset}
        />
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          <div>{children}</div>
          {showCreateAction && (
            <TeamListFooter onCreate={onCreateTeamRequest} />
          )}
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
}
